import { LayoutMoonLogin } from '@orobix/orobix-fe-components'

import AppInfo from '../components/AppInfo/AppInfo'
import AppLogo from '../components/AppLogo/AppLogo'
import EnvInfo from '../components/EnvInfo/EnvInfo'
import { vars } from '../utils/appConfig'
import { getEnvs } from '../utils/env'

const { showEnvBadge } = getEnvs()

interface SignInTemplateProps {
  children: React.ReactChildren
}

const SignInTemplate = ({ children }: SignInTemplateProps): JSX.Element => (
  <LayoutMoonLogin
    appName={vars.appName}
    logo={<AppLogo />}
    info={<AppInfo />}
    envBadge={showEnvBadge && <EnvInfo />}
  >
    {children}
  </LayoutMoonLogin>
)

export default SignInTemplate
